import styles from "./styles.module.scss";
import playBtn from "../../../assets/images/playBtnn.png";
import play from "../../../assets/images/play.png";
import plus from "../../../assets/images/plus.png";
import exclusiveIcon from "../../../assets/images/exclusiveicon.png";
import premiumIcon from "../../../assets/images/premiumicon.png";
import share from "../../../assets/images/share.png";
import shareLight from "../../../assets/images/shareLight.png";
import { useTheme } from "../../../contexts/ThemeContext/ThemeContext";
import { useHistory, useLocation } from "react-router-dom";
import { ExclusiveType, VideoType } from "../../../AppConstants/TypeConstants";
import { getTimeFormat, secondsToHms } from "../../../utils/common.utils";
import { useContext, useEffect } from "react";
import { UserContext } from "../../../contexts/UserContext/UserContextProvider";
import { authContext } from "../../../contexts/AuthContext/AuthContextProvider";
import { AnalyticsContext } from "../../../contexts/Analytics/AnalyticsContextProvider";
import {
  algoliaCustomEvents,
  AlgoliaEventType,
  algoliaIndices,
} from "../../../AppConstants/AlgoliaSearchConstants";
import { VIDEO_CLICK } from "../../../AppConstants/AnalyticsEventName";
import { MediaMetadataContext } from "../../../contexts/MediaMetaDataContext/MediaMetadataContextProvider";
import { videoContext } from "../../../contexts/VideoContext/VideoContextProvider";
import { ConstantDataContext } from "../../../contexts/ConstantContext/ConstantDataContextProvider";
import { getStandaloneVideoData } from "../../../Clevertap/EventHandler.ts";
import { VIDEO_STANDALONE_CLICK_EVENT } from "../../../Clevertap/EventNames.ts";

const EpisodesTab = ({
  videoData = {},

  episodes = [],
  handleInviteBtn,
  setCurrentVideoShare,
  setRestrictedVideo,
  addClickAnalytics,
}) => {
  const { isDark } = useTheme();
  let history = useHistory();
  const { pathname, search = "", hash = "", state } = useLocation();
  const { SearchEvent, addCleverTapAnalytics } = useContext(AnalyticsContext);
  const { userMetadata } = useContext(UserContext);
  // const {playNextVid, setPlayNextVid} = useContext(videoContext)
  const { updateMultipleState } = useContext(authContext);
  const { mediaMetadata } = useContext(MediaMetadataContext);
  const { globalDocflixConstant } = useContext(ConstantDataContext);

  // useEffect(() => {

  //   console.log(playNextVid, "playNexVid");

  //   if (playNextVid && videoData?.videoType === VideoType.VIDEO_STANDALONE && episodes.length > 0) {
  //     setPlayNextVid(false)
  //     changeRoute(episodes[0])
  //   }
  // }, [playNextVid, episodes, videoData]);

  const handlePremiumVideoClick = (episode) => {
    SearchEvent(
      AlgoliaEventType.View,
      algoliaIndices.videos,
      algoliaCustomEvents.normalClick,
      [episode.id]
    );
    addClickAnalytics(VIDEO_CLICK);
    addCleverTapAnalytics(
      VIDEO_STANDALONE_CLICK_EVENT,
      getStandaloneVideoData(episode)
    );
    let goRoute = `/video/${episode.id}`;
    history.push({ pathname: goRoute, search: search });
    if (
      userMetadata.current_plan &&
      (userMetadata.current_plan === ExclusiveType.PREMIUM ||
        userMetadata.current_plan === ExclusiveType.EXCLUSIVE)
    ) {
      setRestrictedVideo(false);
    } else {
      setRestrictedVideo(true);
      return updateMultipleState({ premiumFormModalStart: true });
    }
  };
  const handleExclusiveVideoClick = () => {
    // first check for premium
    if (
      userMetadata.current_plan &&
      userMetadata.current_plan === ExclusiveType.FREE
    ) {
      setRestrictedVideo(true);
      return updateMultipleState({ premiumFormModalStart: true });
    } else if (
      userMetadata.current_plan &&
      userMetadata.current_plan !== ExclusiveType.EXCLUSIVE
    ) {
      setRestrictedVideo(true);
      updateMultipleState({ exclusiveFormModalStart: true });
    } else {
      setRestrictedVideo(false);
    }
  };

  const changeRoute = (episode) => {
    if (episode.type && episode.type !== ExclusiveType.FREE) {
      if (
        episode.type === ExclusiveType.PREMIUM ||
        episode.type === ExclusiveType.EXCLUSIVE
      ) {
        if (episode.type === ExclusiveType.PREMIUM) {
          handlePremiumVideoClick(episode);
        } else if (episode.type === ExclusiveType.EXCLUSIVE) {
          handleExclusiveVideoClick();
        }
      }
    } else {
      SearchEvent(
        AlgoliaEventType.View,
        algoliaIndices.videos,
        algoliaCustomEvents.normalClick,
        [episode.id]
      );
      addClickAnalytics(VIDEO_CLICK);
      addCleverTapAnalytics(
        VIDEO_STANDALONE_CLICK_EVENT,
        getStandaloneVideoData(episode)
      );
      let goRoute = `/video/${episode.id}`;
      history.push({ pathname: goRoute, search: search });
    }
  };

  return (
    <>
      <div className={styles.episodesWrapper}>
        {/* <div className={styles.header}>Episodes({episodes.length})</div> */}
        <div>
          {episodes.length <= 0 ? (
            <div className={styles.noData}>No videos</div>
          ) : (
            episodes.map((episode, index) => {
              let watchedPercentage = mediaMetadata[episode.id]
                ? mediaMetadata[episode.id].lastWatchTimestamp <=
                  mediaMetadata[episode.id].totalDuration
                  ? mediaMetadata[episode.id].lastWatchTimestamp /
                    mediaMetadata[episode.id].totalDuration
                  : 1
                : 0;

              let opacity = 0;

              if (globalDocflixConstant) {
                if (globalDocflixConstant?.videos?.latestTag?.show) {
                  if (episode?.latestTag?.show) {
                    if (episode.timestamp && episode?.latestTag?.timestamp) {
                      let t1 = new Date().valueOf();
                      let t2 = new Date(
                        episode?.latestTag?.timestamp.seconds * 1000
                      ).valueOf();
                      if (t1 < t2) {
                        opacity = 1;
                      }
                    }
                  }
                }
              }

              return (
                <div
                  key={index}
                  className={styles.episodeCard}
                  data-aos="fade-up"
                  data-aos-duration="200"
                  data-aos-delay={index * 50}
                  data-aos-easing="ease-in-sine"
                  data-aos-once="true"
                >
                  <div
                    className={styles.thumbnail}
                    onClick={() => changeRoute(episode)}
                  >
                    <img
                      loading="lazy"
                      src={episode.thumbnailUrl}
                      alt="episode"
                      className={styles.episodeImg}
                    />
                    {/* <img
                    loading="lazy"
                    src={playBtn}
                    alt="play"
                    className={`${styles.playBtn} hvr-bounce-in`}
                  /> */}
                    {episode.type && episode.type !== ExclusiveType.FREE && (
                      <img
                        src={
                          episode.type === ExclusiveType.PREMIUM
                            ? premiumIcon
                            : episode.type === ExclusiveType.EXCLUSIVE
                            ? exclusiveIcon
                            : ""
                        }
                        alt={
                          episode.type === ExclusiveType.PREMIUM
                            ? ExclusiveType.PREMIUM
                            : episode.type === ExclusiveType.EXCLUSIVE
                            ? ExclusiveType.EXCLUSIVE
                            : ""
                        }
                        className={`${styles.videoType} hvr-bounce-in`}
                      />
                    )}
                    <div className={"videoTag"} style={{ opacity: opacity }}>
                      {episode?.latestTag?.text ||
                        globalDocflixConstant?.videos?.latestTag?.text ||
                        "NEW"}
                    </div>
                    <div className={styles.durationBar}>
                      <div
                        style={{
                          width: `${watchedPercentage * 100}%`,
                          backgroundColor: "#EB4547",
                          position: "absolute",
                          height: "6px",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  </div>
                  <div className={styles.details}>
                    <div>
                      {/* <div className={styles.episode}>{`Episode ${index + 1}`}</div> */}
                      <div className={styles.title}>{episode.title}</div>
                      <div className={styles.duration}>
                        {`${getTimeFormat(episode.duration)}`}
                      </div>
                    </div>
                    <div className={styles.btnsWrapper}>
                      <div
                        className={`${styles.actionBtn}`}
                        onClick={() => changeRoute(episode)}
                      >
                        <img loading="lazy" src={play} alt="play" /> Play
                      </div>
                      {/* <div className={`${styles.actionBtn}`}>
                    <img loading="lazy" src={plus} alt="add" /> Add to list
                  </div> */}
                      <div
                        className={`${styles.actionBtn}`}
                        onClick={() => {
                          handleInviteBtn(episode);
                          setCurrentVideoShare && setCurrentVideoShare(episode);
                        }}
                      >
                        <img
                          loading="lazy"
                          src={share}
                          // src={isDark ? share : shareLight}
                          alt="share"
                        />{" "}
                        Share
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
};

export default EpisodesTab;
